module.exports = __webpack_public_path__ + "img/xp2_factory.e8176b1a.jpg";